export const QUERY_PARAMS = {
    utmSource: 'utm_source',
    rwgToken: 'rwg_token',
};
